import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreatePortfolioPage($companyId: ID!, $attributes: PortfolioPageAttributes!) {
    createPortfolioPage(companyId: $companyId, attributes: $attributes) {
      portfolioPage {
        id
        ...CreatedPortfolioPage
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedPortfolioPage on PortfolioPage {
    id
    slug
    title
    body
    description
    enabled
    event { id }
  }
`
